/* Spanish catalog mirroring locale-fr-part7.js. Keys missing here fall back to English. */
window.PlummeI18n.register('es', {
  'bg.balanceDiscrepancy': 'Diferencia de saldo',
  'bg.notCorrect': 'Incorrecto',
  'bg.reconciliationDone': 'La conciliación bancaria está completa',
  'bg.reconciliationDoneHelp': 'El extracto se ha revisado, contabilizado y archivado.',
  'bg.bankLines': 'Líneas bancarias',
  'bg.reconciled': 'Conciliado',
  'bg.backToBank': 'Volver a Banco',
  'bg.reopenReconciliation': 'Reabrir la conciliación',
  'bg.bankAccountCaps': 'CUENTA BANCARIA',
  'bg.periodCaps': 'PERIODO',
  'bg.balanceAtStart': 'Saldo al inicio del periodo',
  'bg.balanceAtEnd': 'Saldo al final del periodo',
  'bg.balancesMatch': 'Los saldos coinciden.',
  'bg.roundingHelp': 'Esto se puede contabilizar en la cuenta de redondeo 7770 sin cambiar el importe del extracto bancario.',
  'bg.balancesMatchContinue': 'Los saldos coinciden – continuar',
  'bg.suggestionsHeading': 'SuperPlumma ha conciliado y propuesto asientos — tú decides',
  'bg.noSuggestions': 'No hay propuestas pendientes de aprobación.',
  'bg.continueToRest': 'Continuar con el resto',
  'bg.noPostedDiscrepancies': 'Ningún asiento contabilizado genera una diferencia.',
  'bg.checkAndFix': 'Revisa y corrige los asientos antes de completar el periodo.',
  'bg.allPaymentsHandled': 'Todos los pagos se han tratado.',
  'bg.continueToVouchers': 'Continuar con los justificantes',
  'bg.allPurchasesDocumented': 'Todas las compras tienen la documentación necesaria o están marcadas como sin justificante.',
  'bg.seePurchase': 'Ver la compra',
  'bg.withoutVoucher': 'Sin justificante',
  'bg.linkSuggested': 'Vincular la propuesta',
  'bg.pickVoucher': 'Elegir justificante',
  'bg.continueToFinish': 'Continuar a la finalización',
  'bg.bankLinesTotal': 'Total de líneas bancarias',
  'bg.linkedPosted': 'Vinculado/contabilizado',
  'bg.privateMovements': 'Movimientos privados',
  'bg.reconcileAndArchive': 'Conciliar y archivar',
  'bg.backAndCheck': 'Volver y revisar',
  'bg.stepModeHelp': 'El modo paso a paso te guía por una tarea a la vez. La vista completa muestra todo junto.',
  'acc.sub': 'Tu perfil y las empresas a las que tienes acceso.',
  'acc.signOutHelp': 'Cierra tu sesión en Plumme. Tendrás que volver a iniciar sesión con tu correo electrónico y contraseña para continuar.',
  'acc.yourRole': 'Tu rol',
  'acc.yourRoleHelp': 'El rol determina lo que puedes hacer: el Propietario tiene acceso completo, el Administrador gestiona la operativa, el Contable lleva la contabilidad y el Lector solo puede consultar. El rol puede variar de una empresa a otra.',
  'acc.editProfile': 'Editar perfil',
  'acc.myBusinesses': 'Mis empresas',
  'acc.myBusinessesHelp': 'Las empresas a las que tienes acceso en Plumme. La etiqueta indica tu rol en cada una. Toca una empresa para abrir su contabilidad.',
  'acc.personalFinanceHelp': 'Finanzas personales es un tipo de cliente independiente para las finanzas personales y del hogar, separado de la contabilidad de las empresas.',
  'acc.goToPersonalFinance': 'Ir a finanzas personales',
  'acc.ownPersonalClient': 'Cliente propio de Finanzas personales',
  'acc.myEmployers': 'Mis empleadores',
  'acc.myEmployersHelp': 'Empresas que te emplean (cuya contabilidad no necesariamente llevas). Aquí encontrarás nóminas, contratos y tu propia página de empleado.',
  'acc.employerPortalAccess': 'Empresas en las que tienes acceso al portal del empleado.',
  'acc.changePicture': 'Cambiar foto',
  'acc.removePicture': 'Quitar foto',
  'acc.photoUploading': 'Subiendo …',
  'acc.photoRemoving': 'Quitando …',
  'acc.photoSaved': 'La foto de perfil se ha actualizado.',
  'acc.photoRemoved': 'La foto de perfil se ha quitado.',
  'acc.photoWrongType': 'Elige una imagen PNG, JPG o WebP.',
  'acc.photoEmpty': 'El archivo de imagen está vacío.',
  'acc.photoTooLarge': 'La imagen es demasiado grande. Máximo 2 MB.',
  'acc.photoUploadFailed': 'No se pudo subir la foto de perfil.',
  'acc.photoRemoveFailed': 'No se pudo quitar la foto de perfil.',
  'acc.photoUnavailable': 'Las fotos de perfil no están disponibles en este momento.',
  'acc.fullName': 'Nombre completo',
  'acc.phoneFromLogin': 'Teléfono de inicio de sesión',
  'acc.changePassword': 'Cambiar contraseña',
  'acc.changes': 'Cambios',
  'acc.noChangeDetails': 'No se guardan más detalles de cambios para este evento.',
  'acc.logSub': 'Lo que se ha hecho en la contabilidad y quién lo ha hecho.',
  'acc.logFilterHelp': 'Filtra el registro por periodo, área (por ejemplo Factura, Nómina, IVA) y por el usuario que realizó la acción.',
  'acc.area': 'Área',
  'acc.areaHelp': 'La parte de la contabilidad a la que afecta la acción, por ejemplo Factura, Compra, Nómina o IVA. Una acción puede afectar a varias áreas.',
  'acc.user': 'Usuario',
  'acc.userHelp': 'La persona que realizó la acción, con su rol. Así puedes ver quién está detrás de cada cambio.',
  'acc.sentLinkTo': 'Hemos enviado un enlace a',
  'bud.annualBudget': 'Presupuesto anual',
  'bud.suggestion': 'Propuesta de presupuesto',
  'bud.createSuggestion': 'Crear una propuesta',
  'bud.startSimpleQuestions': 'Empezar con preguntas sencillas',
  'bud.fillRelevant': 'Rellena solo lo que sea relevante. Los importes mensuales se convierten en presupuesto anual.',
  'bud.businessDescription': 'Descripción de la actividad',
  'bud.businessDescriptionPh': 'Ej. una agencia de transporte para 2027 con 2 furgonetas, 2 empleados, un alquiler de oficina de 8 000/mes y más ingresos en verano.',
  'bud.howToBudget': 'Cómo crear un presupuesto',
  'bud.howToBudgetHelp': 'Elige un método: con «Manual» introduces las cuentas tú mismo, con «Propuesta» respondes a unas preguntas sencillas y obtienes un borrador, y con «Propuesta con IA» describes la actividad con tus propias palabras y Plumme crea un borrador.',
  'bud.budgetedResult': 'Resultado presupuestado',
  'bud.budgetedResultHelp': 'El resultado presupuestado para todo el año: ingresos presupuestados menos gastos presupuestados. Es el objetivo hacia el que te diriges.',
  'bud.actualResult': 'Resultado real',
  'bud.actualResultHelp': 'El resultado real contabilizado en lo que va de año: ingresos reales menos gastos reales. Compáralo con el presupuesto para ver si vas según lo previsto.',
  'bud.postedSoFar': 'contabilizado hasta ahora',
  'bud.varianceToPeriod': 'Desviación en el periodo',
  'bud.varianceToPeriodHelp': 'La diferencia entre el resultado real y el presupuestado hasta ahora. Una desviación negativa significa que estás por debajo del presupuesto, una positiva que estás por encima.',
  'bud.incomeTarget': 'Objetivo de ingresos',
  'bud.incomeTargetHelp': 'Qué parte de los ingresos presupuestados del año has alcanzado hasta ahora: ingresos realmente facturados divididos entre los ingresos presupuestados.',
  'bud.ofTargetReached': 'del objetivo alcanzado',
  'bud.viewHelp': 'Cambia de vista: «Resumen» muestra el resultado acumulado y la mayor desviación, «Análisis» muestra ingresos y gastos así como el resultado por mes, y «Presupuesto por categoría» es donde introduces y modificas los importes.',
  'bud.accumulatedResult': 'Resultado acumulado',
  'bud.accumulatedResultHelp': 'El gráfico muestra el resultado que se va formando mes a mes a lo largo del año. La línea discontinua es el presupuesto, la continua lo realmente contabilizado: así ves si sigues el plan.',
  'bud.budgetAtYearEnd': 'Presupuesto a final de año',
  'bud.accumulated': 'acumulado',
  'bud.actualSoFar': 'Real hasta ahora',
  'bud.posted': 'contabilizado',
  'bud.varianceSoFar': 'Desviación hasta ahora',
  'bud.largestVariance': 'Mayor desviación',
  'bud.largestVarianceHelp': 'La cuenta que más se desvía del presupuesto en lo que va de año. Útil para ver rápidamente dónde te pasas más o te quedas más corto respecto a lo previsto.',
  'bud.soFarThisYear': 'en lo que va de año',
  'bud.incomeVsCost': 'Ingresos frente a gastos por mes',
  'bud.incomeVsCostHelp': 'Las barras muestran los ingresos (verde) frente a los gastos (naranja) de cada mes. Alterna entre cifras reales, presupuestadas o ambas. Toca un mes para sumar una selección.',
  'bud.resultPerMonth': 'Resultado por mes',
  'bud.resultPerMonthHelp': 'Muestra el resultado (ingresos menos gastos) de cada mes, presupuesto frente a real. Las barras por encima de la línea central son beneficio, por debajo pérdida.',
  'bud.actual': 'Real',
  'bud.actualByCategory': 'Real por categoría',
  'bud.actualByCategoryHelp': 'Ingresos y gastos contabilizados por cuenta, repartidos por mes. Las cifras proceden de tu contabilidad, tanto los justificantes registrados en Plumme como las cifras importadas, y se actualizan automáticamente.',
  'bud.noActuals': 'Todavía no hay cifras contabilizadas para {year}.',
  'bud.actualOnlyHint': 'Estas son cifras reales. Introduce un presupuesto en Presupuesto si quieres medirte frente a un plan.',
  'bud.byCategory': 'Presupuesto por categoría',
  'bud.addIncome': 'Añadir ingreso',
  'bud.addIncomeHelp': 'Añade una categoría de ingresos con un importe anual, por ejemplo las ventas previstas. El importe se reparte entre los meses y puedes ajustarlo.',
  'bud.addCost': 'Añadir gasto',
  'bud.addCostHelp': 'Añade una categoría de gastos con un importe anual, por ejemplo alquiler, compras de mercancías o software. El importe se reparte entre los meses y puedes ajustarlo.',
  'bud.noCategories': 'Todavía no hay categorías de presupuesto. Añade un ingreso o un gasto.',
  'bud.useLastYear': 'Usar el año anterior',
  'bud.simpleQuestions': 'Preguntas sencillas',
  'bud.byCategoryHelp': 'Cada fila es una categoría de presupuesto. Los importes de los 12 meses están siempre visibles y se pueden editar directamente en la tabla, con el total anual a la derecha.',
  'bud.total': 'Total',
  'bud.annualTotal': 'Total anual',
  'bud.annualTotalHelp': 'Si editas esta cifra directamente, el nuevo importe anual se reparte de forma uniforme entre los 12 meses.',
  'bud.save': 'Guardar',
  'bud.methodManual': 'Manual',
  'bud.methodSuggestion': 'Propuesta',
  'bud.methodAi': 'Propuesta con IA',
  'bud.modeBudgeted': 'Presupuestado',
  'bud.modeBoth': 'Ambos',
  'bud.forWholeYear': 'para todo {year}',
  'bud.underBudget': 'por debajo del presupuesto',
  'bud.overBudget': 'por encima del presupuesto',
  'bud.legendBudgetDashed': '- - Presupuesto',
  'bud.legendBudgetSolid': '— Presupuesto',
  'bud.legendActual': '— Real',
  'bud.noVarianceYet': 'Todavía no hay desviación',
  'bud.savedToast': 'Presupuesto guardado',
  'bud.saveFailedToast': 'No se pudo guardar el presupuesto',
  'bud.aiModalTitle': 'Presupuesto con IA para {year}',
  'bud.aiDraftBusy': 'Creando borrador...',
  'bud.aiDraftCreate': 'Crear borrador con IA',
  'bud.aiDescription': 'Describe la empresa con tus propias palabras: empleados, salarios, activos, gastos fijos y estacionalidad. Cuanto más detalle, mejor será el borrador.',
  'bud.aiDraftFailedGeneric': 'No he podido crear un borrador de presupuesto a partir de la descripción. Añade más detalle o usa Propuesta.',
  'bud.aiDraftAppliedToast': 'Borrador de IA añadido. Pulsa Guardar cuando te parezca bien.',
  'bud.aiDraftFailed': 'Ha fallado el borrador de presupuesto con IA.',
  'bud.suggestionIntro': 'Crea una propuesta a partir de las cifras reales del año pasado, o responde a unas preguntas sencillas para obtener un presupuesto inicial.',
  'bud.catSales': 'Venta de bienes y servicios',
  'bud.catPurchases': 'Compras de mercancías y costes directos',
  'bud.catPremises': 'Locales',
  'bud.catSoftware': 'Software y equipamiento',
  'bud.catAccounting': 'Contabilidad y asesoría',
  'bud.catTravel': 'Viajes',
  'bud.catMarketing': 'Marketing',
  'bud.catCommunication': 'Teléfono, correo y comunicación',
  'bud.otherCosts': 'Otros gastos',
  'bud.customCategory': 'Categoría personalizada',
  'bud.q.expectedIncome.label': '¿Cuánto esperas ganar?',
  'bud.q.expectedIncome.hint': 'Ingresos facturados previstos para todo el año.',
  'bud.q.goodsAnnual.label': 'Compras de mercancías',
  'bud.q.goodsAnnual.hint': 'Mercancías o materiales que compras para revender.',
  'bud.q.officeMonthly.label': 'Oficina/locales por mes',
  'bud.q.officeMonthly.hint': 'Alquiler, espacio de oficina o locales.',
  'bud.q.softwareMonthly.label': 'Software por mes',
  'bud.q.softwareMonthly.hint': 'Suscripciones, herramientas y aplicaciones.',
  'bud.q.accountingMonthly.label': 'Contabilidad/asesoría por mes',
  'bud.q.accountingMonthly.hint': 'Contable, asesor u otra ayuda.',
  'bud.q.travelAnnual.label': 'Coche/viajes por año',
  'bud.q.travelAnnual.hint': 'Desplazamientos, viajes, hoteles o transporte.',
  'bud.q.marketingAnnual.label': 'Marketing por año',
  'bud.q.marketingAnnual.hint': 'Anuncios, imagen de marca y gastos comerciales.',
  'bud.q.otherAnnual.hint': 'Deja un margen para lo que todavía no sabes.',
  'aii.superPlumma': 'SuperPlumma',
  'aii.askSuperPlumma': 'Preguntar a SuperPlumma',
  'aii.chatWithSuperPlumma': 'Chatear con SuperPlumma',
  'aii.chatWithMe': 'Chatea conmigo',
  'aii.healthScore': 'Puntuación de salud financiera',
  'po.title': 'Finanzas personales',
  'po.backToBusiness': 'Volver a la empresa',
  'po.yourAdvisor': 'Tu asesor personal',
  'po.intro': 'Las finanzas personales son la economía de tu hogar, totalmente separada de la contabilidad de la empresa. SuperPlumma analiza los ingresos, gastos, ahorro, préstamos, pensión e impuestos del hogar y te aconseja como lo haría un asesor financiero personal. «Beta» significa que la función aún está en desarrollo.',
  'po.hero.greeting.night': 'Buenas noches.',
  'po.hero.greeting.morning': 'Buenos días.',
  'po.hero.greeting.day': 'Hola.',
  'po.hero.greeting.evening': 'Buenas tardes.',
  'po.hero.greetingNamed.night': 'Buenas noches, {name}.',
  'po.hero.greetingNamed.morning': 'Buenos días, {name}.',
  'po.hero.greetingNamed.day': 'Hola, {name}.',
  'po.hero.greetingNamed.evening': 'Buenas tardes, {name}.',
  'po.hero.section.idag': 'Consejo de hoy',
  'po.hero.section.oversikt': 'Resumen financiero',
  'po.hero.section.forbruk': 'Gastos',
  'po.hero.section.familie': 'Finanzas familiares',
  'po.hero.section.fremtid': 'Plan de futuro',
  'po.hero.section.reports': 'Informes',
  'po.hero.section.assets': 'Patrimonio',
  'po.hero.section.gjeld': 'Deudas',
  'po.hero.section.import': 'Datos de base',
  'po.hero.advice.idag': 'Vigilo de cerca tus finanzas y destaco las tareas y oportunidades más importantes del momento.',
  'po.hero.advice.oversikt': 'Mira qué hace subir y bajar tu salud financiera. Empieza por el área que más atención necesita.',
  'po.hero.advice.forbruk': 'Busca las categorías que han aumentado y elige una medida realista que te dé margen sin apretar demasiado el día a día.',
  'po.hero.advice.familie': 'Aclara qué es compartido, quién paga qué y qué objetivos debe priorizar el hogar en conjunto.',
  'po.hero.advice.fremtid': 'Concreta tus objetivos con un importe y una fecha. Así será más fácil ver cuánto deberías ahorrar cada mes.',
  'po.hero.advice.reports': 'Usa los informes para entender la evolución en el tiempo, en lugar de fijarte en un mes inusualmente alto o bajo.',
  'po.hero.advice.assets': 'Comprueba que los valores y los saldos de las cuentas están actualizados antes de evaluar tu patrimonio neto y tus decisiones a largo plazo.',
  'po.hero.advice.gjeld': 'Prioriza primero un colchón de seguridad y después considera amortizaciones anticipadas de la deuda con el tipo de interés efectivo más alto.',
  'po.hero.advice.import': 'Un buen consejo empieza con buenos datos. Vincula los extractos a la cuenta correcta y rellena los huecos en los periodos importados.',
  'po.pickPerson': 'Elegir persona',
  'po.sections': 'Secciones',
  'po.sectionsHelp': 'Cambia entre las áreas: Hoy (ideas del día), Resumen (puntuación de salud y cifras clave), Gastos (adónde va el dinero), Familia, Futuro (previsión y «¿y si…?»), Informes, Patrimonio, Deudas, Impuestos e Importar.',
  'po.outOf100': 'de 100',
  'po.todaysFocus': 'Prioridad de hoy',
  'po.todaysTasks': 'Tareas de hoy',
  'po.mostImportantToday': 'Lo más importante hoy',
  'po.markDone': 'Marcar como hecho',
  'po.undo': 'Deshacer',
  'po.healthHeading': 'Tu salud financiera global y lo que la mueve',
  'po.healthHelp': 'El número del anillo (0–100) es una valoración global de tus finanzas: cuanto más alto, más sanas. Las categorías de abajo muestran qué la hace subir y bajar: el verde es bueno, el naranja significa que hay que vigilarlo y el rojo requiere acción.',
  'po.noHistory': 'Todavía no hay historial con el que comparar',
  'po.whatAffectsScore': 'Lo que más influye en la puntuación',
  'po.noDrivers': 'Todavía no se han calculado factores',
  'po.noDriversHelp': 'Cuando haya suficientes transacciones importadas, te mostraré qué hace subir y bajar la puntuación.',
  'po.last30Days': 'Último mes registrado',
  'po.last30DaysSub': 'En comparación con el mes natural anterior',
  'po.financialOverview': 'Resumen financiero',
  'po.financialOverviewSub': 'Una instantánea de las finanzas del hogar',
  'po.recommendations': 'Recomendaciones de SuperPlumma',
  'po.recommendationsSub': 'Las medidas que más importan para tus finanzas ahora mismo',
  'po.askMe': 'Pregúntame',
  'po.yourHealthScoreIs': 'Tu puntuación de salud es',
  'po.adjustBudget': 'Ajustar presupuesto',
  'po.budgetTotal': 'Total del presupuesto:',
  'po.saveBudget': 'Guardar presupuesto',
  'po.monthlyLimitPerCategory': 'Límite mensual por categoría',
  'po.noCategoriesImported': 'Todavía no se han importado categorías de gasto. Añade tus propias categorías abajo.',
  'po.ownCategories': 'Categorías propias',
  'po.pickColour': 'Elegir color',
  'po.categoryName': 'Nombre de la categoría',
  'po.removeCategory': 'Quitar categoría',
  'po.addCategory': 'Añadir categoría',
  'po.budgetVsSpending': 'Presupuesto y gastos',
  'po.budgetVsSpendingSub': 'Límite mensual frente al gasto en el periodo seleccionado',
  'po.budgetVsSpendingHelp': 'Presupuesto mensual frente al gasto real por categoría. Pulsa «Ajustar presupuesto» para fijar los límites o crear tus propias categorías. La barra de progreso se llena según la parte del presupuesto utilizada: el verde indica que estás dentro, el naranja que te acercas al límite y el rojo que la categoría se ha superado. Si eliges el resumen anual, el límite mensual se multiplica por el número de meses con datos importados. Los presupuestos se guardan para el año seleccionado.',
  'po.whereMoneyGoes': '¿Adónde va el dinero?',
  'po.whereMoneyGoesSub': 'Toca una categoría para ver las transacciones que hay detrás y moverlas al lugar correcto',
  'po.whereMoneyGoesHelp': 'El gráfico circular y la lista muestran el gasto repartido por categoría en el periodo seleccionado. Cambia de periodo con el botón de arriba: los meses sin transacciones importadas aparecen en gris. Toca una categoría para resaltarla. El porcentaje de la derecha es la variación respecto al mes anterior: verde hacia abajo significa menos, rojo hacia arriba significa más.',
  'po.selectPeriod': 'Seleccionar periodo',
  'po.yearOverview': 'Resumen anual',
  'po.yearly': 'Anual',
  'po.month.1': 'Enero',
  'po.month.2': 'Febrero',
  'po.month.3': 'Marzo',
  'po.month.4': 'Abril',
  'po.month.5': 'Mayo',
  'po.month.6': 'Junio',
  'po.month.7': 'Julio',
  'po.month.8': 'Agosto',
  'po.month.9': 'Septiembre',
  'po.month.10': 'Octubre',
  'po.month.11': 'Noviembre',
  'po.month.12': 'Diciembre',
  'po.largestCategoryIs': 'La mayor categoría de gasto es',
  'po.recurringCharges': 'Cargos recurrentes que revisar',
  'po.recurringChargesSub': 'Cargos recurrentes de suscripción que quizá convenga comprobar',
  'po.opportunity': 'Oportunidad',
  'po.estimatedAnnualCost': 'Coste anual estimado',
  'po.saveAccount': 'Guardar cuenta',
  'po.allAccounts': 'Todas las cuentas',
  'po.uploadedStatements': 'Extractos subidos',
  'po.yourAccounts': 'Tus cuentas',
  'po.yourAccountsSub': 'Registra y ordena tus cuentas por tipo: los extractos importados se vinculan a la cuenta correcta',
  'po.totalBalance': 'Saldo total',
  'po.creditDebt': 'Deuda de tarjeta de crédito',
  'po.accounts': 'Cuentas',
  'po.analysis': 'Análisis de SuperPlumma',
  'po.analysisSub': 'Cómo se reparte el gasto de la categoría y qué puedes hacer',
  'po.whoIsBehind': 'Quién está detrás',
  'po.noTransactionsToAnalyse': 'Todavía no hay transacciones que analizar.',
  'po.unusualPurchases': 'Compras inusuales',
  'po.noUnusualPurchases': 'Ninguna compra destaca en este periodo.',
  'po.searchTransactions': 'Buscar transacciones …',
  'po.clearSearch': 'Borrar búsqueda',
  'po.sort': 'Ordenar',
  'po.linkStatementToAccount': 'Vincular el extracto a una cuenta',
  'po.linkToAccount': 'Vincular a una cuenta',
  'po.newAccount': 'Nueva cuenta',
  'po.accountNamePh': 'Ej. Cuenta corriente DNB',
  'po.accountNumberPh': 'Ej. 1234.56.78901',
  'po.currentAccount': 'Cuenta corriente',
  'po.creditCard': 'Tarjeta de crédito',
  'po.me': 'yo',
  'po.importTitle': 'Importar datos financieros',
  'po.importSub': 'Sube extractos bancarios: SuperPlumma los lee y los categoriza automáticamente',
  'po.pickStatement': 'Elegir un extracto bancario',
  'po.pickStatementHelp': 'Sube los extractos de tu banco. Los archivos XLSX y CSV se leen directamente; los PDF se leen lo mejor posible a partir del texto. SuperPlumma categoriza las transacciones automáticamente.',
  'po.pdf': 'PDF',
  'po.noStatementsUploaded': 'Todavía no se ha subido ningún extracto bancario.',
  'po.deleteStatement': 'Eliminar extracto',
  'po.sharedCosts': 'Aportación a los gastos compartidos',
  'po.sharedCostsSub': 'Quién paga qué de los gastos compartidos y cómo se compara con la parte de ingresos',
  'po.sharedCostsHelp': 'La barra muestra qué parte de los gastos compartidos del hogar cubre cada uno de ustedes. A la derecha está la parte de los ingresos totales. Si ambas son iguales, el reparto es proporcional a los ingresos. Las cifras proceden de lo que cada uno ha introducido en su propio perfil.',
  'po.splitIsEven': 'El reparto es equilibrado. Ustedes comparten',
  'po.togetherYouCan': 'Juntos pueden',
  'po.togetherYouCanSub': 'Pequeñas medidas que pueden tomar en equipo, calculadas a partir de las cifras del propio hogar',
  'po.togetherHelp': 'Las sugerencias se calculan a partir de los ingresos totales y los gastos compartidos que habéis introducido. Son objetivos comunes, no exigencias individuales.',
  'po.sharedSteps': 'Medidas conjuntas',
  'po.magnitude': 'Orden de magnitud',
  'po.youPartnerPh': 'Tú, pareja …',
  'po.monthlyNetIncome': 'Ingresos netos mensuales',
  'po.sharedCostShare': 'Parte de los gastos compartidos por mes',
  'po.familyFinances': 'Finanzas familiares',
  'po.addPerson': 'Añadir persona',
  'po.noHouseholdMembers': 'Todavía no hay miembros del hogar registrados.',
  'po.householdHasRegistered': 'El hogar ha registrado',
  'po.todaysPlan': 'Plan de hoy',
  'po.savePlan': 'Guardar plan',
  'po.monthlySaving': 'Ahorro mensual (NOK)',
  'po.monthlyExtraDebt': 'Amortización extra mensual de deuda (NOK)',
  'po.targetNetWealth': 'Patrimonio neto deseado (NOK)',
  'po.expectedReturn': 'Rentabilidad anual esperada (%)',
  'po.yourAgeToday': 'Tu edad hoy (años)',
  'po.desiredRetirementAge': 'Edad de jubilación deseada (años)',
  'po.pickEvent': 'Elegir un evento',
  'po.eventNamePh': 'Ej. Segundo hijo',
  'po.starts': 'Inicio',
  'po.oneOffCost': 'Coste puntual (NOK)',
  'po.monthlyEffect': 'Efecto mensual (NOK)',
  'po.durationMonths': 'Duración (meses)',
  'po.goalName': 'Nombre del objetivo',
  'po.goalNamePh': 'Ej. Fondo de emergencia',
  'po.shortDescription': 'Descripción breve',
  'po.whatSavingFor': '¿Para qué estás ahorrando?',
  'po.targetAmount': 'Importe objetivo (NOK)',
  'po.savedSoFar': 'Ahorrado hasta ahora (NOK)',
  'po.icon': 'Icono',
  'po.colour': 'Color',
  'po.debtFree': 'Sin deudas',
  'po.saveLoan': 'Guardar préstamo',
  'po.loanType': 'Tipo de préstamo',
  'po.spendingCategory': 'Categoría en Gastos',
  'po.categoryPh': 'Ej. Vivienda',
  'po.debtOverview': 'Resumen de deudas',
  'po.debtOverviewSub': 'Todos tus préstamos juntos: deuda pendiente, intereses y ritmo de amortización',
  'po.debtOverviewHelp': 'Las cifras clave de todas tus deudas: deuda pendiente total, lo que amortizas al mes, coste de intereses al año, tipo medio y cuánto falta para quedar sin deudas.',
  'po.totalDebt': 'Deuda total',
  'po.repaymentPerMonth': 'Amortización por mes',
  'po.interestPerYear': 'Intereses por año',
  'po.averageRate': 'Tipo medio',
  'po.debtFreeIn': 'Sin deudas en',
  'po.loanCount': 'Número de préstamos',
  'po.yourLoans': 'Tus préstamos',
  'po.yourLoansSub': 'Toca un préstamo para ver el plan de amortización y simular cambios',
  'po.addLoan': 'Añadir préstamo',
  'po.noLoans': 'Todavía no hay préstamos introducidos. Pulsa «Añadir préstamo» para empezar.',
  'po.whichLoanFirst': '¿Qué préstamo deberías amortizar primero?',
  'po.whichLoanFirstSub': 'Ordenados por tipo de interés: empezar por el préstamo más caro es lo que más rinde por cada corona extra',
  'po.iRecommend': 'Recomiendo',
  'po.snowballWithRate': 'el método del tipo de interés (método avalancha)',
  'po.repaymentSimSub': 'Mira cómo baja la deuda pendiente y simula qué pasa si pagas más o menos cada mes',
  'po.myRecommendation': 'Mi recomendación',
  'po.withChange': 'Con el cambio',
  'po.extraRepaymentPerMonth': 'Amortización extra por mes',
  'po.dragToPayMore': 'Arrastra para pagar más (sin deudas antes) o menos (plazo más largo)',
  'po.standard': 'Estándar',
  'po.savedInInterest': 'Ahorro en intereses',
  'po.overWholeTerm': 'durante todo el plazo',
  'po.netWealthEffect': 'Efecto en el patrimonio neto',
  'po.becomesYours': 'es tuyo, no del banco',
  'po.interestPostedAs': 'Los intereses y cuotas de este préstamo se contabilizan como',
  'po.debtJourney': 'Tu camino hacia quedar sin deudas',
  'po.debtJourneySub': 'Los hitos principales hasta quedar completamente sin deudas',
  'po.yourFinancialFuture': 'Tu futuro financiero',
  'po.yourFinancialFutureSub': 'Adónde te lleva el dinero y cómo tus decisiones dan forma al camino',
  'po.showingScenario': 'Escenario mostrado:',
  'po.reset': 'Restablecer',
  'po.desiredNetWealth': 'Patrimonio neto deseado',
  'po.lastsUntilYouAre': 'dura hasta que tengas',
  'po.lasts': 'dura',
  'po.forLife': 'de por vida',
  'po.plummaReadsChart': 'SuperPlumma interpreta el gráfico',
  'po.whatIf': '¿Y si…?',
  'po.whatIfSub': 'Fija el punto de partida en el plan de hoy, elige una decisión y ajusta las hipótesis: el gráfico, los objetivos, las fechas y la pensión se actualizan a la vez',
});
